import {
    Stack,
    Text,
    useDisclosure,
    Collapse,
} from '@chakra-ui/react'

import { FaAngleDown } from "react-icons/fa";

const MobileFilterButton = ({ label, content }) => {
    const { isOpen, onToggle } = useDisclosure()
    return (
        <>
            <Stack
                as={'button'}
                border={'1px solid'}
                borderColor={'gray.300'}
                py={2}
                px={4}
                align={'center'}
                variant={'outline'}
                borderRadius={'full'}
                justify={'space-between'}
                direction={'row'}
                onClick={onToggle}
            >
                <Text>{label}</Text>
                <FaAngleDown />
            </Stack>
            <Collapse in={isOpen} animateOpacity>
                {content}
            </Collapse>
        </>
    )
}

export default MobileFilterButton